export const CUSTOM_DOMAIN_SETTINGS_PENDING_STATUSES = [
  'pending',
  'initializing',
  'pending_validation',
];
